import { createSlice, PayloadAction } from "@reduxjs/toolkit";
type userType =
  | "EMPLOYER"
  | "PATIENT"
  | "ADMIN_USER"
  | "PROVIDER"
  | "EMPLOYER_ADMINISTRATION"
  | "EMPLOYEE"
  | "PHP_USER"
  | "AFFILIATE_FIRM"
  | null;

interface InvoiceState {
  selectedUserType: userType;
}

const initialState: InvoiceState = {
  selectedUserType: null,
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setSelectedUserType: (state, action: PayloadAction<userType>) => {
      state.selectedUserType = action.payload;
    },
  },
});

export const { setSelectedUserType } = invoiceSlice.actions;

export default invoiceSlice.reducer;
